module.exports = __webpack_public_path__ + "static/media/73070014-vGf1wSgs.70fceca5.JPG";